import Axios from 'axios'
// import * as Security from '@/common/security_manager'
// import Vue from 'vue'
import CommonUtils from "./CommonUtils";

Axios.defaults.headers.common.Accept = 'application/json';

// Add a response interceptor
Axios.interceptors.response.use((response) => {
    // Do something with response data
    // Vue.$log.info("Response ", response)

    return response;
}, function (error) {
    // Do something with response error
    const response = error.response;
    console.log(response);
    if (response.status === 401) {
        ///logout
        console.log('12312')

    }

    return Promise.reject(error);
});

// Add a request interceptor
Axios.interceptors.request.use((config) => {
    // Do something before request is sent
    // const tokenObj = Security.getTokenObject();

    config.withCredentials = false;
    config.headers = {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Origin: "http://admin.notaxi.info",
        'Authorization': 'Bearer ' + CommonUtils.getCookie('token')
    };

    // Vue.$log.info("Request Config ", config)

    return config;
}, function (error) {
    // Do something with request error
    console.log(error)
    return Promise.reject(error);
});
